<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4>Usuarios</h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usuarioaud in datosPaginados" :key="usuarioaud.idUsuarioAud">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(usuarioaud.idUsuarioAud)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(usuarioaud.idUsuarioAud)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteUsuarioAud(usuarioaud.idUsuarioAud)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAud" class="form-label"
                      >IdUsuarioAud</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioAud"
                      name="idUsuarioAud"
                      v-model="datoUsuarioAud.idUsuarioAud"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuario" class="form-label">IdUsuario</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuario"
                      name="idUsuario"
                      v-model="datoUsuarioAud.idUsuario"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPerfil"
                      name="idPerfil"
                      v-model="datoUsuarioAud.idPerfil"
                    >
                      <option
                        v-for="perfil in perfils"
                        :value="perfil.idPerfil"
                        :key="perfil.idPerfil"
                      >
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label">
                      Suscripcion</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idSuscripcion"
                      name="idSuscripcion"
                      v-model="datoUsuarioAud.idSuscripcion"
                    >
                      <option
                        v-for="suscripcion in suscripcions"
                        :value="suscripcion.idSuscripcion"
                        :key="suscripcion.idSuscripcion"
                      >
                        {{ suscripcion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoUsuarioAud.nombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="clave" class="form-label">Clave</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="clave"
                      name="clave"
                      v-model="datoUsuarioAud.clave"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label"
                      >IdUsuarioReg</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioReg"
                      name="idUsuarioReg"
                      v-model="datoUsuarioAud.idUsuarioReg"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label"
                      >IdUsuarioAct</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioAct"
                      name="idUsuarioAct"
                      v-model="datoUsuarioAud.idUsuarioAct"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      v-model="datoUsuarioAud.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaAct"
                      name="fechaAct"
                      v-model="datoUsuarioAud.fechaAct"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarUsuarioAud"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarUsuarioAud"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      usuarioauds: [],
      datoUsuarioAud: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      perfils: [],
      suscripcions: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPerfils();
    this.fetchSuscripcions();
  },
  methods: {
    totalPaginas() {
      return Math.ceil(this.usuarioauds.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwusuarioauds/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.usuarioauds = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.usuarioauds.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwusuarioauds")
        .then((response) => {
          this.usuarioauds = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.usuarioauds.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idUsuario",
        "idPerfil",
        "idSuscripcion",
        "nombre",
        "clave",
      ];
      const requiredFieldsText = [
        "idUsuario",
        "idEmpresa",
        "idPerfil",
        "idSuscripcion",
        "nombre",
        "clave",
      ];
      return validarForm(
        this.datoUsuarioAud,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarUsuarioAud() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuarioAud.idUsuario =
            window.sessionStorage.getItem("idUsuario");
          this.datoUsuarioAud.idEmpresa =
            window.sessionStorage.getItem("idEmpresa");
          this.datoUsuarioAud.idUsuarioReg =
            window.sessionStorage.getItem("idUsuarioReg");
          await api.post("/usuarioauds",
            this.datoUsuarioAud
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "UsuarioAud creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarUsuarioAud() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuarioAud.idUsuarioAct =
            window.sessionStorage.getItem("idUsuarioAct");
          await api.post("/usuarioauds",
            this.datoUsuarioAud
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "UsuarioAud creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoUsuarioAud = {};
      this.titulo = "Crear Usuarios";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idUsuarioAud) {
      this.modalWindow = true;
      if (idUsuarioAud != null) {
        api.get("/vwusuarioauds/" + idUsuarioAud)
          .then((resp) => {
            this.datoUsuarioAud = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Usuarios";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idUsuarioAud) {
      if (idUsuarioAud != null) {
        this.$router.push("/usuarioaudmd/" + idUsuarioAud);
      }
    },
    async deleteUsuarioAud(idUsuarioAud) {
      try {
        await api.delete("/usuarioauds/" + idUsuarioAud
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchPerfils() {
      fetch(config.apiBaseUrl + "/perfils")
        .then((response) => response.json())
        .then((data) => {
          this.perfils = data;
        })
        .catch((error) => {
          console.error("Error fetching perfils:", error);
        });
    },
    fetchSuscripcions() {
      fetch(config.apiBaseUrl + "/suscripcions")
        .then((response) => response.json())
        .then((data) => {
          this.suscripcions = data;
        })
        .catch((error) => {
          console.error("Error fetching suscripcions:", error);
        });
    },
  },
};
</script>
